import { BroadbandQuote } from '@src/types/broadband';

export const getDownstreamSpeed = ({ product }: BroadbandQuote): number =>
  (product.details.speeds ?? []).reduce(
    (max, speed) => Math.max(max, parseFloat(speed?.downstreamAverage ?? '0')),
    0
  );

export const sortTariffsBySpeed = (
  quotes: BroadbandQuote[]
): BroadbandQuote[] =>
  [...quotes].sort((a, b) => getDownstreamSpeed(b) - getDownstreamSpeed(a));
